export default function Phase2() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Phase Header */}
        <div className="flex items-center justify-center mb-8">
          <img 
            src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160517458/settings_images/c821fd2-60ad-dfbb-b7b-3c7076dbb748_0a9554db-dfc8-42b5-bbf2-fe0e7fe8eafe.png" 
            alt="Phase Icon" 
            className="w-16 h-16"
          />
        </div>

        <div className="max-w-4xl mx-auto text-left mb-12">
          <h4 className="text-xl font-bold text-gray-900 mb-2">
            <span>Phase 2:</span>
          </h4>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            <span>How to Grow With AI Content</span>
          </h2>
        </div>

        {/* Intro Text */}
        <div className="max-w-3xl mx-auto mb-12">
          <p className="text-base text-gray-700 mb-4">I'm going to hit you with a harsh reality.</p>
          <p className="text-base text-gray-700 mb-4">Content only matters if it's worth watching...</p>
          <p className="text-base text-gray-700 mb-4">And most people don't know how to create content that's actually worth watching.</p>
          <p className="text-base text-gray-700 mb-4">This course will show you the RIGHT way to create content that will leave people begging for more.</p>
          <p className="text-base text-gray-700 mb-8">We break things down into 4 different categories.</p>
          <h4 className="text-2xl font-bold text-gray-900">#1 Viral Short Form Content</h4>
        </div>

        {/* Viral Short Form Video */}
        <div className="max-w-3xl mx-auto mb-12">
          <div 
            className="relative w-full mb-8 overflow-hidden rounded-lg" 
            style={{ 
              paddingBottom: '56.25%',
              touchAction: 'pan-y',
              WebkitOverflowScrolling: 'touch'
            }}
          >
            <iframe 
              src="https://fast.wistia.net/embed/iframe/io99uokhpp?web_component=true&seo=true&playsinline=1&autoplay=1&muted=1" 
              title="Viral Social Content Video" 
              allow="autoplay; fullscreen" 
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg"
              style={{ 
                border: 'none',
                pointerEvents: 'auto',
                maxWidth: '100%',
                maxHeight: '100%'
              }}
              loading="lazy"
            ></iframe>
          </div>

          <p className="text-base text-gray-700 mb-4">Instagram, TikTok, Facebook, Youtube shorts...</p>
          <p className="text-base text-gray-700 mb-4">These are platforms that complete beginners can go viral on if they have the right formula behind their content.</p>
          <p className="text-base text-gray-700 mb-4">Normally it requires expensive cameras, complicated software, and days spent behind a computer to get out one quality post.</p>
          <p className="text-base text-gray-700 mb-8">Now you can do it all in a fraction of the time with almost ZERO cost using Artificial intelligence.</p>
        </div>

        {/* Viral Views Image */}
        <div className="max-w-4xl mx-auto mb-12">
          <img 
            src="https://static.readdy.ai/image/1ee33a74a7d817227244af36e3fd2b0e/4ca3d58a0842b4884504d63098eff069.jpeg" 
            alt="Viral Views" 
            className="w-full rounded-lg"
          />
        </div>

        <div className="max-w-3xl mx-auto mb-12">
          <p className="text-base text-gray-700 mb-8">Whether you're starting from scratch or supplementing your existing content strategy with AI. This course will leave you with an endless stream of viral content ideas, and the means to turn those ideas into a reality.</p>
          <h4 className="text-2xl font-bold text-gray-900">#2 Youtube Long Form Content</h4>
        </div>

        {/* YouTube Video */}
        <div className="max-w-3xl mx-auto mb-12">
          <div 
            className="relative w-full mb-8 overflow-hidden rounded-lg" 
            style={{ 
              paddingBottom: '56.25%',
              touchAction: 'pan-y',
              WebkitOverflowScrolling: 'touch'
            }}
          >
            <iframe 
              src="https://player.mediadelivery.net/embed/555127/f554dd6d-505d-4e2f-9cc9-7b80e2d4d2c8?autoplay=true&loop=true&muted=true&playsinline=true" 
              title="youtube videos" 
              allow="autoplay; fullscreen" 
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg"
              style={{ 
                border: 'none',
                pointerEvents: 'auto',
                maxWidth: '100%',
                maxHeight: '100%'
              }}
              loading="lazy"
            ></iframe>
          </div>

          <p className="text-base text-gray-700 mb-4">When I got started on youtube. It would take 1-2 weeks just to finish one video and get it posted on youtube.</p>
          <p className="text-base text-gray-700 mb-4">Today... it's a completely different world.</p>
          <p className="text-base text-gray-700 mb-4">With AI, we're able to produce professional youtube videos faster than ever before, and the results have been off the charts.</p>
          <p className="text-base text-gray-700 mb-8">What you see below is the results in our first year of implementing AI in our Youtube content strategy</p>
        </div>

        {/* YouTube Results Image */}
        <div className="max-w-4xl mx-auto mb-12">
          <img 
            src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2162203163/settings_images/277aa38-45-5be-c2e3-21380df48d_YT_AI_results.png" 
            alt="YouTube AI Results" 
            className="w-full rounded-lg"
          />
        </div>

        <div className="max-w-3xl mx-auto mb-12">
          <p className="text-base text-gray-700 mb-8">In this course we pull back the curtain and show you exactly how we're using AI to work smarter, get more views, and grow our brand faster than ever before.</p>
          <h4 className="text-2xl font-bold text-gray-900">#3 Profitable Ads</h4>
        </div>

        {/* Profitable Ads Video */}
        <div className="max-w-3xl mx-auto mb-12">
          <div 
            className="relative w-full mb-8 overflow-hidden rounded-lg" 
            style={{ 
              paddingBottom: '56.25%',
              touchAction: 'pan-y',
              WebkitOverflowScrolling: 'touch'
            }}
          >
            <iframe 
              src="https://fast.wistia.net/embed/iframe/p4rqqfozf4?web_component=true&seo=true&playsinline=1&autoplay=1&muted=1" 
              title="Profitable Ads Video" 
              allow="autoplay; fullscreen" 
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg"
              style={{ 
                border: 'none',
                pointerEvents: 'auto',
                maxWidth: '100%',
                maxHeight: '100%'
              }}
              loading="lazy"
            ></iframe>
          </div>

          <p className="text-base text-gray-700 mb-4">After spending over $275,000 testing AI ads, we learned one thing above all else...</p>
          <p className="text-base text-gray-700 mb-4">AI ads are absolutely CRUSHING it right now.</p>
          <p className="text-base text-gray-700 mb-4">Time and time again, our top performing advertisements on Facebook, instagram, google, and youtube are made with AI.</p>
          <p className="text-base text-gray-700 mb-8">They're outperforming the ads we spent days painstakingly creating with real cameras and complicated editing software.</p>
        </div>

        {/* Revenue Image */}
        <div className="max-w-3xl mx-auto mb-12">
          <img 
            src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2162203163/settings_images/716b72-22ce-028b-3c26-1c345f41c006_821k_month.png" 
            alt="Revenue Results" 
            className="w-full rounded-lg"
          />
        </div>

        <div className="max-w-3xl mx-auto mb-12">
          <p className="text-base text-gray-700 mb-4">Why is this happening?</p>
          <p className="text-base text-gray-700 mb-4">It's simple...</p>
          <p className="text-base text-gray-700 mb-4">Because you can create wildly more interesting, funny, and engaging ads with AI.</p>
          <p className="text-base text-gray-700 mb-4">And this is what viewers want.</p>
          <p className="text-base text-gray-700 mb-4">The world of advertising is changing and if you don't embrace these new trends, you'll be left behind wondering why it always feels like you're lighting your marketing budget on fire.</p>
          <p className="text-base text-gray-700 mb-4">Oh... and if you're just getting started launching a product or business.</p>
          <p className="text-base text-gray-700 mb-8">The best thing you can do (from both a time and money perspective) is start with AI ads.</p>
          <h4 className="text-2xl font-bold text-gray-900">#4 Short Films</h4>
        </div>

        {/* Short Films Video */}
        <div className="max-w-3xl mx-auto mb-12">
          <div 
            className="relative w-full mb-8 overflow-hidden rounded-lg" 
            style={{ 
              paddingBottom: '56.25%',
              touchAction: 'pan-y',
              WebkitOverflowScrolling: 'touch'
            }}
          >
            <iframe 
              src="https://fast.wistia.net/embed/iframe/qkuz6q3vme?web_component=true&seo=true&playsinline=1&autoplay=1&muted=1" 
              title="Short films Video" 
              allow="autoplay; fullscreen" 
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg"
              style={{ 
                border: 'none',
                pointerEvents: 'auto',
                maxWidth: '100%',
                maxHeight: '100%'
              }}
              loading="lazy"
            ></iframe>
          </div>

          <p className="text-base text-gray-700 mb-4">Are your daydreams filled with incredible ideas for short films?</p>
          <p className="text-base text-gray-700 mb-4">With Artificial intelligence, you can finally bring these ideas to life and amaze your friends &amp; family.</p>
          <p className="text-base text-gray-700">Every day, AI technology is advancing and this course will ensure you stay up to date on latest and greatest techniques to create visually stunning, emotionally driven videos.</p>
        </div>
      </div>
    </section>
  );
}
